/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/style.css";

export const onClientEntry = () => {
  // Mark body as loaded to hide SSR placeholders
  if (typeof document !== 'undefined') {
    document.body.classList.add('announcement-loaded');
  }
};